export class KeyToNoteNumber {
	public static readonly QWERTY = new Map<string, number>([
		// Octave 1
		['z', 0],
		[',', 1],
		['x', 2],
		['.', 3],
		['c', 4],
		['v', 5],
		['k', 6],
		['b', 7],
		['l', 8],
		['n', 9],
		[';', 10],
		['m', 11],
		// Octave 2
		['a', 12],
		['i', 13],
		['s', 14],
		['o', 15],
		['d', 16],
		['f', 17],
		['p', 18],
		['g', 19],
		['[', 20],
		['h', 21],
		[']', 22],
		['j', 23],
		// Octave 3
		['q', 24],
		['8', 25],
		['w', 26],
		['9', 27],
		['e', 28],
		['r', 29],
		['0', 30],
		['t', 31],
		['-', 32],
		['y', 33],
		['=', 34],
		['u', 35],
		// Octave 4
		['1', 36],
		['/', 37],
		['2', 38],
		['\'', 39],
		['3', 40],
		['4', 41],
		['\\', 42],
		['5', 43],
		['Delete', 44],
		['6', 45],
		['Insert', 46],
		['7', 47],
	]);
}
